import React, { useState } from "react";
import { Star } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { TASK } from "@/constants/testIds";

export default function RatingPanel({ taskId, onDone }) {
  const [stars, setStars] = useState(5);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/tasks/${taskId}/rate`, { stars, comment });
      onDone(data.rating);
      toast.success("Thank you for rating!");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="eb-card p-6">
      <h3 className="text-xl font-[800]">Rate this errand</h3>
      <p className="text-sm text-[var(--eb-text-dim)] mt-1">Your feedback helps maintain agent trust.</p>
      <div className="mt-4 flex gap-2">
        {[1, 2, 3, 4, 5].map((n) => (
          <button key={n} data-testid={`${TASK.rateStars}-${n}`} onClick={() => setStars(n)}>
            <Star
              className={`w-7 h-7 ${
                n <= stars
                  ? "text-[var(--eb-primary)] fill-[var(--eb-primary)]"
                  : "text-[var(--eb-text-faint)]"
              }`}
            />
          </button>
        ))}
      </div>
      <textarea
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        className="eb-input mt-4"
        rows="3"
        placeholder="What went well?"
      />
      <div className="mt-4 flex justify-end">
        <button
          data-testid={TASK.rateSubmit}
          onClick={submit}
          disabled={busy}
          className="eb-btn eb-btn-primary"
        >
          {busy ? "Submitting…" : "Submit rating"}
        </button>
      </div>
    </div>
  );
}
